var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '../styles/checkBox.scss';
import globalStore from '../store';
import { getImageSrc } from '../helper/imageBlobCache';
var CheckBox = function (props) {
    var _a;
    var id = props.id, className = props.className, _b = props.label, label = _b === void 0 ? '' : _b, _c = props.style, style = _c === void 0 ? {} : _c, _d = props.checked, checked = _d === void 0 ? false : _d, _e = props.onClick, onClick = _e === void 0 ? function () { } : _e, labelCSS = props.labelCSS, ariaLabel = props.ariaLabel, disabled = props.disabled;
    var checkBtn = globalStore.useStoreState(function (state) { return state.jsonDataStore; }).btnConfig.checkBtn;
    return (_jsxs("div", { className: "checkBoxWrapper ".concat(className), style: __assign({}, style), children: [_jsxs("div", { className: "checkBtn ".concat(checked ? 'checkBtn_active' : ''), children: [_jsx("input", { type: "checkbox", id: id, checked: checked, disabled: disabled, "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : (label || undefined), "aria-labelledby": id && label ? "".concat(id, "_label") : undefined, tabIndex: (_a = props.tabIndex) !== null && _a !== void 0 ? _a : 0, onChange: function (e) { return onClick(e); }, onKeyDown: function (e) {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                onClick(e);
                            }
                        }, style: {
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            opacity: 0,
                            margin: 0,
                            cursor: disabled ? 'default' : 'pointer',
                            zIndex: 1,
                        } }), _jsx("span", { className: "checkBoxSpan" }), checked && _jsx("img", { src: getImageSrc(checkBtn.imgSrc.active), alt: "", className: "tickImage" })] }), label !== '' && (_jsxs("label", { id: id ? "".concat(id, "_label") : undefined, className: "labelCSS ".concat(labelCSS, " ").concat(disabled ? "".concat(labelCSS, "_disable") : ""), "aria-hidden": "true", tabIndex: -1, children: [' ', label] }))] }));
};
export default CheckBox;
